import { layouts, productOptions } from "./data";
import type { HouseConfiguration, RuleResult } from "./types";

export function validateConfiguration(configuration: HouseConfiguration): RuleResult {
  const messages: string[] = [];
  const layout = layouts.find((item) => item.id === configuration.layoutId);

  if (layout && configuration.areaM2 < layout.minArea) {
    messages.push(`${layout.name} kræver mindst ${layout.minArea} m².`);
  }
  if (configuration.carport && configuration.areaM2 < 112) {
    messages.push("Carport kan vælges fra 112 m².");
  }
  if (configuration.bedrooms >= 4 && configuration.areaM2 < 128) {
    messages.push("Fire værelser kræver mindst 128 m².");
  }
  if (configuration.bedrooms >= 5 && configuration.areaM2 < 144) {
    messages.push("Fem værelser kræver mindst 144 m².");
  }

  configuration.options.forEach((id) => {
    const option = productOptions.find((item) => item.id === id);
    if (option?.requiresRoof && option.requiresRoof !== configuration.roofMaterialId) {
      messages.push(`${option.name} kræver sort ståltag i denne demo.`);
    }
  });

  return { valid: messages.length === 0, messages };
}
